import { router } from '@inertiajs/vue3'

export function useVersionable() {
  const selectVersion = (leftVersion, rightVersion) => {
    router.reload({
      only: ['leftVersionId', 'leftVersion', 'rightVersionId', 'rightVersion'],
      data: {
        'left-version': leftVersion,
        'right-version': rightVersion,
      },
    })
  }

  return {
    selectVersion,
  }
}
